import { render, staticRenderFns } from "./InputFileProfile.vue?vue&type=template&id=972a0fc2&scoped=true"
import script from "./InputFileProfile.vue?vue&type=script&lang=js"
export * from "./InputFileProfile.vue?vue&type=script&lang=js"
import style0 from "./InputFileProfile.scss?vue&type=style&index=0&id=972a0fc2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972a0fc2",
  null
  
)

export default component.exports